import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "vab-icon-right_line",
  "use": "vab-icon-right_line-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"vab-icon-right_line\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.7072 11.293C16.0977 11.6835 16.0977 12.3167 15.7072 12.7072L10.0503 18.3641C9.65984 18.7546 9.02668 18.7546 8.63615 18.3641C8.24563 17.9735 8.24563 17.3404 8.63615 16.9498L13.5859 12.0001L8.63615 7.05037C8.24563 6.65985 8.24563 6.02668 8.63615 5.63616C9.02668 5.24563 9.65984 5.24563 10.0503 5.63616L15.7072 11.293Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol